module.exports = __webpack_public_path__ + "img/anchor.f5796258.jpg";